import { isString } from '@grandvisionhq/utils';

const getMetaTitle = (variant, product)=>[
        variant.metaTitle,
        product.metaTitle,
        variant.displayName
    ].find(isString)
;
const getCLMetaTitle = (variant, product, localizedReplacementFrequency)=>{
    // i.e. "Monthly Acuvue Oasys"
    const defaultTitle = [
        localizedReplacementFrequency,
        variant.displayName
    ].filter(Boolean).join(' ');
    return [
        variant.metaTitle,
        product.metaTitle,
        defaultTitle
    ].find(isString);
};
const getMetaDescription = (variant, product)=>[
        variant.metaDescription,
        product.metaDescription,
        variant.description,
        product.description
    ].find(isString)
;

export { getCLMetaTitle, getMetaDescription, getMetaTitle };
//# sourceMappingURL=get-product-seo-info.js.map
